import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectLandingState } from './selectLandingState'

export const selectLandingIsRefreshing = createSelector(
  [selectLandingState],
  ({ refreshLandingStatus }) => {
    return refreshLandingStatus === RequestStatus.PENDING
  }
)
